<template>
    <div id="vehicleDisplay">
        <vehicle-description-page-pc v-if="displayVehicleDescriptionPagePC"/>
        <vehicle-description-page v-if="displayVehicleDescriptionPage"/>
    </div>
</template>

<script>
    import VehicleDescriptionPagePC from '../components/VehicleDescriptionPagePC.vue';
    import VehicleDescriptionPage from '../components/VehicleDescriptionPage.vue';

    export default {
        props: [
            'vehicleInfo',
            'crashed'
        ],
        data() {
            return {
                vehicleNotFound: false
            }
        },
        components: {
            'vehicle-description-page-pc': VehicleDescriptionPagePC,
            'vehicle-description-page': VehicleDescriptionPage
        },
        beforeCreate() {
            //this.$store.commit('setWelcomePopupOpenStatus', false);

            if(this.$store.getters.vehicleGallerySelected == null) {
                this.$store.dispatch('getVehicleFromURL', {vehicleInfo: this.vehicleInfo, crashRequest: (this.crashed && this.crashed == 'crashed')});
            }
        },
        beforeRouteUpdate(to, from, next) {
            if(this.$store.getters.vehicleGallerySelected == null) {
                this.$store.dispatch('getVehicleFromURL', {vehicleInfo: this.vehicleInfo, crashRequest: (this.crashed && this.crashed == 'crashed')});
            }

            next();
        },
        computed: {
            displayVehicleDescriptionPagePC() {
                return this.$store.getters.vehicleGallerySelected != null && !this.$store.getters.isMobile;
            },
            displayVehicleDescriptionPage() {
                return this.$store.getters.vehicleGallerySelected != null && this.$store.getters.isMobile;
            }
        }
    }
</script>

<style>
</style>